module.exports = __webpack_public_path__ + "media/images/other-header-ing-mobile-ea17d0e6435dfb587f6bddb90671e3f4.png";